import type { SwitchProps as AntdSwitchProps } from 'antd'
import { Switch as AntdSwitch } from 'antd'
import { useState } from 'react'

interface SwitchProps {
  name?: string
  defaultChecked?: boolean
  checked?: boolean
  labelOff?: string
  labelOn?: string
  'aria-label'?: string
  'aria-labelledby'?: string
  onChange?: AntdSwitchProps['onChange']
  className?: string
  switchClassName?: string
  labelOffClassName?: string
  labelOnClassName?: string
}

export default function Switch({
  name,
  defaultChecked,
  checked,
  labelOff,
  labelOn,
  onChange = () => {},
  className,
  switchClassName = 'mx-2!',
  labelOffClassName,
  labelOnClassName,
  'aria-label': ariaLabel,
  'aria-labelledby': ariaLabelledBy,
  ...props
}: SwitchProps & AntdSwitchProps) {
  const controlledInput = typeof checked !== 'undefined'

  const [inputChecked, setInputChecked] = useState(() => (controlledInput ? Boolean(checked) : Boolean(defaultChecked)))
  const currentLabel = (controlledInput ? checked : inputChecked) ? labelOn : labelOff

  const handleChange: NonNullable<AntdSwitchProps['onChange']> = (val, e) => {
    if (controlledInput) {
      onChange(val, e)
    } else {
      setInputChecked(val)
    }
  }

  const checkedProp = {
    ...(typeof checked !== 'undefined' ? { checked } : {}),
  }

  return (
    // Just add a width here from parent component and you're done
    <div className={`flex items-center ${className || ''}`}>
      {labelOff && <div className={labelOffClassName || 'text-nowrap'}>{labelOff}</div>}
      <AntdSwitch
        defaultChecked={defaultChecked}
        onChange={handleChange}
        className={switchClassName}
        aria-label={ariaLabel ?? (!ariaLabelledBy ? currentLabel : undefined)}
        aria-labelledby={ariaLabelledBy}
        {...checkedProp}
        {...props}
      />
      {labelOn && <div className={labelOnClassName || 'text-nowrap'}>{labelOn}</div>}
      {name && (
        <input
          type="checkbox"
          value="true"
          name={name}
          checked={controlledInput ? checked : inputChecked}
          onChange={() => {}}
          hidden
          readOnly
        />
      )}
    </div>
  )
}
